<script>
import baseMixin from '@/mixins/baseMixin'
import FormSubmissionWithSchemaVM from '@/models/forms/formSubmissionWithSchemaVM'
import FormSubmissionFieldControl from './form-submission-field-control.vue'
import FormSubmissionStateLabel from './form-submission-state-label.vue'

export default {
  name: 'FormSubmissionDetails',
  components: {
    FormSubmissionFieldControl,
    FormSubmissionStateLabel,
  },
  mixins: [baseMixin],
  props: {
    form: {
      type: FormSubmissionWithSchemaVM,
      required: true,
    },
  },
  computed: {
    schema() {
      return this.form.schema
    },
    submission() {
      return this.form.submission
    },
  },
  methods: {
    getSubmissionValueByKey(key) {
      const foundValue = this.submission.values[key]
      return foundValue || foundValue === 0 ? foundValue : null
    },
  },
}
</script>

<template>
  <div>
    <v-card class="rounded-xl custom-elevation pb-4 px-2">
      <v-card-title class="mb-0 pb-0">
        <BasePageTitle :title="schema.name" :subtitle="schema.description">
          <template v-slot:title>
            <BasePageTitleHeader>
              {{ schema.name }}
              <span class="caption opacity-7">
                version {{ schema.versionNo }}
              </span>
              <FormSubmissionStateLabel :state="submission.state" />
            </BasePageTitleHeader>
          </template>
        </BasePageTitle>
      </v-card-title>
      <v-card-text
        v-for="group of schema.formDefinition.groups"
        :key="group.key"
      >
        <h4 class="font-weight-medium">{{ group.label }}</h4>
        <p class="text-subtitle-2">{{ group.description }}</p>
        <v-divider />
        <FormSubmissionFieldControl
          v-for="field of group.fields"
          :key="field.key"
          class="mt-6"
          :field="field"
          :value="getSubmissionValueByKey(field.key)"
        />
      </v-card-text>
    </v-card>
  </div>
</template>
